import { render, staticRenderFns } from "./Groupes.vue?vue&type=template&id=59826453&"
import script from "./Groupes.vue?vue&type=script&lang=js&"
export * from "./Groupes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports